const viewAny = (permissions) => {
  return permissions.includes('read-regions')
}

const create = (permissions) => {
  return hasPermission(permissions, 'create-regions')
}

const update = (permissions, region) => {
  return hasPermission(permissions, 'update-regions')
}

const deletee = (permissions, region) => {
  return hasPermission(permissions, 'delete-regions')
}

const hasPermission = (permissions, permission) => {
  return permissions.includes(permission)
}

export {
  viewAny,
  create,
  update,
  deletee,
  hasPermission,
};